<template>
                <div class="news-items mt54">
                    
                    <a href="https://mp.weixin.qq.com/s/0Ngn9kYlFRu0M9T54bBjUQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1679898542479305.jpg" alt="前沿分享 | 黄江南朱嘉明：观念经济学原理及其现实意义" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">01/31<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">前沿分享 | 黄江南朱嘉明：观念经济学原理及其现实意义</div>
                                <div class="desc">经济学是一门历史科学。传统经济学不仅不再可以作为国家经济发展战略和决策的理论基础，而且可能误导我国经济在传统物质生产，传统工业化道路，传统经济增长模式上的徘徊甚至停滞不前。现在到了用全新经济学补充和替代传统经济学的历史时刻。经过多年思考、探索、研究，二位教授提出了“观念经济学”的理论思想。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/L2e-uBpOek5cxmo_0651oA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1672302370891273.jpg" alt="澳门，数字贸易新高地" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">12/15<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">澳门，数字贸易新高地</div>
                                <div class="desc">建设中葡数字贸易新高地 「星火·链网」国际超级节点（澳门）正式发布</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mbd.baidu.com/newspage/data/landingsuper?rs=975043874&amp;ruk=CkQYcYchIQ4c2_CYzH3I9g&amp;sShare=1&amp;isBdboxFrom=1&amp;pageType=1&amp;urlext=%7B%22cuid%22%3A%220a2kiY8dH8_6P2aNga-zi_uVH8_vav8lluvcfjuY28YLuSt6YuvIf_ipWPr8iQa_F_wmA%22%7D&amp;context=%7B%22nid%22%3A%22news_9199516156189912134%22%7D" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1671608804168234.jpg" alt="链接湾区 融贯全球：“星火·链网”国际超级节点落地澳门" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">12/15<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">链接湾区 融贯全球：“星火·链网”国际超级节点落地澳门</div>
                                <div class="desc">2022年12月15日，由澳门特别行政区政府经济及科技发展局和中国信息通信研究院（以下简称“中国信通院”）指导，澳门质量品牌国际认证联盟、中国信通院工业互联网与物联网研究所、浪潮⼯业互联⽹股份有限公司主办，澳门融贯科技投资有限公司协办的“链接湾区 融贯全球”2022 第二届数字贸易创新应用峰会暨“星火·链网”国际超级节点（澳门）发布会在澳门举行。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://m.itouchtv.cn/program/5160/10/664447?shareId=Nlea8FWB" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1667971642429868.jpg" alt="南方财经报道：广东省工业互联网十年变革 | “古老”茶产业搭上“年轻”区块链" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">11/04<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">南方财经报道：广东省工业互联网十年变革 | “古老”茶产业搭上“年轻”区块链</div>
                                <div class="desc">近日，南方财经在广东省工业互联网十年变革专栏报道了由融贯国际联合浪潮集团、广州国际茶叶交易中心、广州神农智联农业科技发展有限公司打造的，基于“星火·链网”横琴粤澳链的茶叶溯源系统。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/2RbRKAwmVc9BpqU0-0mBOw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1666689712996096.jpg" alt="融贯链网协同创数字经济新局，澳门数字经济创新应用论坛圆满收官" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/22<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">融贯链网协同创数字经济新局，澳门数字经济创新应用论坛圆满收官</div>
                                <div class="desc">22日下午，以 「“区”动创新 “链”接未来」为主题的澳门数字经济创新应用论坛在MIF澳门馆签约中心成功举办。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/A7CRSfqssMYgMPTK5M8tEw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1666690249186615.jpg" alt="第27届MIF | 融贯国际精彩展示多元化数字经济创新应用" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/20<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">第27届MIF | 融贯国际精彩展示多元化数字经济创新应用</div>
                                <div class="desc">20日起，第27届澳门国际贸易投资展览会（MIF）、澳门国际品牌连锁加盟展2022（MFE）和2022年葡语国家产品及服务展（澳门）（PLPEX）三大展会同期同场举行。澳门质量品牌国际认证联盟馆主要展示了基于星火·链网骨干节点（珠海横琴）——横琴粤澳链的多元化创新应用服务，打造数字技术与实体经济相融合的成功范例，从而进一步增强澳门监造、澳门监制、澳门设计在国际数字贸易中的影响力，助推粤澳地区链网协同高质量发展。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://m.chinanews.com/wap/detail/chs/zw/hm63135c4528e7c5505c5e7982.shtml" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1662619387945829.png" alt="推动湾区品质认证，打造“澳门监制”平台" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/02<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">推动湾区品质认证，打造“澳门监制”平台</div>
                                <div class="desc">9月2日，澳门融贯与国内著名质量技术服务机构CVC威凯就推动湾区品质认证，打造“澳门监制”平台签订战略合作协议。签署仪式在CVC威凯广州总部举行，澳门工商联会常务理事长、澳门融贯董事长冯文滔，CVC威凯副总经理罗军波代表双方签字。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://m.chinanews.com/wap/detail/chs/zw/hm630e2ef492b75e4ddcc7fd83.shtml" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1661929467215129.jpg" alt="融贯国际与广西将军峰茶叶集团在2022年粤企入桂“双百”行动启动仪式签署合作协议" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">08/31<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">融贯国际与广西将军峰茶叶集团在2022年粤企入桂“双百”行动启动仪式签署合作协议</div>
                                <div class="desc">8月29-30日，2022年粤企入桂“双百”行动启动仪式暨广西现代农业产业链招商洽谈会在广西梧州市举办。融贯国际总经理陈祥作为企业代表出席，并与广西著名茶企将军峰茶叶集团有限公司就“星火链网数字认证服务平台”项目签署了合作协议。</div>
                            </div>
                        </div>
                    </a>
                    
                   
                </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

  </style>